var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-tkani-filters"},[_c('layout-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_c('div',{staticClass:"container"},[_vm._t("default",null,{"select":_vm.select,"filterCheck":_vm.filterCheck})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }